/**
 *
 * Description. Localstorage
 *
 * @link   URL
 * @file   Handles all the localstorage functions like add, remove and get
           Stores user login session info and retrive it.
 * @since  1.0.0
 */
import app from "../helpers/appGlobal";
import {
  getLocalStorage,
  setToLocalStorage,
  removeFromLocalStorage
} from "./storage";

const mainKey = "LEDADMINloginRes";

export const checkCookie = cookieName => {
  const cookieArr = document.cookie.split("; ");
  if (cookieArr && cookieArr.length) {
    return cookieArr.find(row => row.startsWith(cookieName));
  }
  return "";
};

export const setResData = res => {
  app.user = res;
};

export const setToStorage = res => {
  setToLocalStorage(res, mainKey);
};

export const getLocalStorageData = () => {
  return getLocalStorage(mainKey);
};

export const getAndSetData = () => {
  setResData(getLocalStorageData());
};

// update specific values for user
export const updateToLocalStorage = dataArr => {
  const res = getLocalStorageData();
  dataArr.forEach(v => {
    const { name, value } = v;
    app.user[name] = value;
    res[name] = value;
  });
  setToStorage(res);
};

export const deleteCookie = name => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
};

// Logout the user and remove localstorage data
export const removeOnLogout = (isNoReload, pageName) => {
  removeFromLocalStorage(mainKey);
  app.user = {};
  if (!isNoReload) {
    let redirectUrl = `${process.env.PUBLIC_URL}`;
    if (pageName) {
      redirectUrl = `${process.env.PUBLIC_URL}/${pageName}`;
    }
    window.location.replace(redirectUrl);
  }
};
